// src/components/CookieBanner.jsx
import { useState, useEffect } from "react";

const STORAGE_KEY = "pp_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-banner-text">
        <strong>We use essential cookies</strong> to keep you signed in. Firebase Authentication
        requires session cookies to function. We do not use advertising or tracking cookies.{" "}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        {" · "}
        <a href="/security" target="_blank" rel="noopener noreferrer">Data Security</a>
      </div>
      <div className="cookie-banner-actions">
        <button className="cookie-accept-btn" onClick={accept}>
          Accept &amp; Continue
        </button>
        <a href="/data-choices" target="_blank" rel="noopener noreferrer" className="cookie-manage-btn">
          Manage Preferences
        </a>
      </div>
    </div>
  );
}
